import { ENROLMENT_FORM_SECTIONS } from '@pages/enrolment/constants.js';
import useGlobalStore from '@stores/global';

const enrolmentSectionComponents = {
  'applicant-details': () => import('@pages/enrolment/forms/applicant-details.vue'),
  'contact-household': () => import('@pages/enrolment/forms/contact-household.vue'),
  'employment-education': () => import('@pages/enrolment/forms/employment-education.vue'),
  'sign-and-confirm': () => import('@pages/enrolment/forms/sign-and-confirm.vue'),
  'marketing-options': () => import('@pages/enrolment/forms/marketing-options.vue'),
  'residency-and-id': () => import('@pages/enrolment/forms/residency-and-id.vue'),
};

const enrolmentSectionRoutes = ENROLMENT_FORM_SECTIONS.map(section => ({
  path: section.id,
  name: section.routeName,
  component: enrolmentSectionComponents[section.id],
  meta: {
    title: 'Enrolment form',
    sectionId: section.id,
    sectionNumber: section.sectionNumber,
  },
}));

const applicationIdProp = route => ({ applicationId: Number(route.params.applicationId) });

// With no application to open, the layout shows its message on the profile page instead.
function redirectToLastOrNewestApplication() {
  const applicationId = useGlobalStore().lastOrNewestApplicationId;
  return applicationId === null ? { name: 'profile' } : { name: 'hub', params: { applicationId } };
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@pages/auth/login-page.vue'),
    meta: { title: 'Sign in', public: true },
  },
  {
    path: '/sign/employer',
    name: 'employer-signing',
    component: () => import('@pages/employer-signing/employer-signing-page.vue'),
    meta: { title: 'Sign the compliance pack', public: true },
  },
  {
    path: '/',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: 'root',
        // Never shown, as entering always redirects. Not a `redirect`, as those run before the
        // session guard has loaded the applications.
        component: { render: () => null },
        beforeEnter: redirectToLastOrNewestApplication,
      },
      {
        path: 'applications/:applicationId(\\d+)',
        children: [
          {
            path: '',
            name: 'hub',
            component: () => import('@pages/hub/hub-page.vue'),
            props: applicationIdProp,
            meta: { title: 'Home' },
          },
          {
            path: 'enrolment',
            name: 'enrolment',
            component: () => import('@pages/enrolment/enrolment-page.vue'),
            props: applicationIdProp,
            meta: { title: 'Enrolment form' },
            children: enrolmentSectionRoutes,
          },
          {
            path: 'documents',
            name: 'documents',
            component: () => import('@pages/documents-review/documents-page.vue'),
            props: applicationIdProp,
            meta: { title: 'Compliance documents' },
          },
        ],
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@pages/profile/profile-page.vue'),
        meta: { title: 'Profile' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('@pages/not-found-page.vue'),
        meta: { title: 'Page not found' },
      },
    ],
  },
];

export default routes;
